import { ConfigProvider } from "antd";
import { darkTheme } from "@ant-design/compatible";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { useEffect } from "react";
import { NavBar } from "../components/general";
import SelectedStoryworldProvider from "../context/SelectedStoryworldProvider";
import { NavFooter } from "../components";
import { AppLayout, ContentLayout } from "./Layout";
import OffscreenTrigger from "../components/OffscreenTrigger";
import AuthProvider from "../context/AuthProvider";
import ScrollOffscreenProvider from "../context/ScrollOffscreenProvider";
import BackLocationsProvider from "../context/BackLocationsProvider";
import ContentGate from "../components/ContentGate";
import SignupModal from "../components/login/SignupModal";
import WaitlistModal from "../components/modals/WaitlistModal";
import { ErrorBoundary } from "react-error-boundary";
import RouterErrorBoundary from "./RouterErrorBoundary";
import ScrollToHash from "../components/layout/ScrollToHash";
import { pingApiHealth } from "../lib/apiHeartbeat";

// https://ant.design/docs/react/migrate-less-variables#how-to-use-component-token
export const antdDarkTheme = {
  ...darkTheme,
  token: {
    // Blurple
    colorPrimary: "#505dff",
  },
  components: {
    Layout: {
      bodyBg: "#212121",
    },
    Popover: {
      colorBgElevated: "#212121",
    },
    Notification: {
      colorBgElevated: "transparent",
      boxShadow: "none",
    },
    Table: {
      headerSortHoverBg: "#424242",
    },
    Skeleton: {
      gradientFromColor: "#424242",
    },
  },
};

export default function Presto() {
  useEffect(() => {
    void pingApiHealth();
  }, []);

  return (
    <ConfigProvider theme={antdDarkTheme}>
      <AuthProvider>
        <BackLocationsProvider>
          <ScrollOffscreenProvider>
            <SelectedStoryworldProvider>
              <AppLayout>
                <ScrollToHash />
                <Container>
                  <NavBar />
                  <ContentLayout>
                    <ErrorBoundary FallbackComponent={RouterErrorBoundary}>
                      <Outlet />
                    </ErrorBoundary>
                  </ContentLayout>
                  <NavFooter />
                </Container>
                <OffscreenTrigger />
              </AppLayout>
              <ContentGate />
              <SignupModal />
              <WaitlistModal />
            </SelectedStoryworldProvider>
          </ScrollOffscreenProvider>
        </BackLocationsProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

const Container = styled.div`
  overflow-x: clip;
  min-width: 0;

  .ant-menu-item {
    margin-bottom: 14px !important;
  }
`;
